import React from "react";
// sonner
import { Toaster } from "sonner";
// @Mui
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
// react-i18next
import "src/locales/i18n";
// recoil
import { RecoilRoot, useRecoilValue } from "recoil";
// theme
import ThemeProvider from "./theme";
// routes
import Router from "./routes";
// atoms
import { themeAtom } from "./recoil";
//
import DeleteConfirmationPopUp from "./components/DeleteConfirmationPopUp";
import InstallPWAPopUp from "./components/InstallPWAPopUp";

// ---------------------------------------------------------------------------------

function App() {
  const theme = useRecoilValue(themeAtom);

  const cacheRtl = createCache({
    key: theme.dir === "rtl" ? "muirtl" : "mui",
    stylisPlugins: [rtlPlugin, prefixer],
  });

  return (
    <>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <CssBaseline />
          <Router />
          {/* Sonner Toast */}
          <Toaster
            toastOptions={{
              style: { backgroundColor: "transparent", border: "none" },
            }}
          />
          <InstallPWAPopUp />
          {/* Delete Confirmation Pop Up */}
          <DeleteConfirmationPopUp />
        </LocalizationProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
